import React from 'react'
import EcommerceDashboardCard from '../../layouts/EcommerceDashboardCard';
// import EcommerceDashboardCard from '../../layouts/EcommerceDashboardCard';

const SubsDashboardCard = ({ status, onCardViewClick, activeIndex }) => {
    console.log('status', status);

  return (
    <div className='row px-3 d-flex justify-content-center'>
      {/* <div style={{ position: 'relative' }} className='col-md-4 col-12 my-1' onClick={() => onCardViewClick(1)}>
        <EcommerceDashboardCard count={status.length > 1 ? status[1].count : 0} isActive={window.location.pathname == '/discount-percentage/view' || window.location.pathname == '/discount-percentage/view'} activatedProducts={true} awaitingProducts={false} cardName={'Active Subscription'} />
      </div> */}
      <div style={{ position: 'relative' }} className='col-md-4 col-12 my-1' onClick={() => onCardViewClick(1)}>
        <EcommerceDashboardCard count={status?.activeCount ?? 0} isActive={activeIndex == 1 ? true : false} activatedProducts={true} awaitingProducts={false} cardName={'Active Subscription'} />
      </div>

      <div style={{ position: 'relative' }} className='col-md-4 col-12 my-1' onClick={() => onCardViewClick(2)}>
        <EcommerceDashboardCard count={status?.canceledCount ?? 0} isActive={activeIndex == 2 ? true : false} activatedProducts={true} awaitingProducts={false} cardName={'Cancelled Subscription'} />
      </div>
      <div style={{ position: 'relative' }} className='col-md-4 col-12 my-1' onClick={() => onCardViewClick(3)}>
        <EcommerceDashboardCard count={status?.completedCount ?? 0} isActive={activeIndex == 3 ? true : false} activatedProducts={true} awaitingProducts={false} cardName={'Completed Subscription'} />
      </div>
    </div>
  );
};

export default SubsDashboardCard;